import React from 'react';
import { Button, Col, Row } from 'components';
import { ArrowLeftIcon } from 'components/common/icons';
import { ActiveTasks } from 'feature';
import { Details } from 'pages/admin/clients/client/details';
import styles from 'pages/admin/clients/client/styles.module.scss';
import { TabNav } from 'pages/admin/clients/client/tabNav';

export const Client = React.memo(() => {
  return (
    <Row className={styles.client}>
      <Col>
        <Button title={'Click to go back'} onClick={() => history.back()} type={'link'} icon={<ArrowLeftIcon />} />
      </Col>
      <Col className={styles.main_section}>
        <Row wrap={false}>
          <Col flex={'296px'}>
            <Row className={styles.left_banner}>
              <Col>
                <Details />
              </Col>
              <Col className={styles.active_tasks}>
                <ActiveTasks />
              </Col>
            </Row>
          </Col>
          <Col flex={'1'} className={styles.right_section}>
            <TabNav />
          </Col>
        </Row>
      </Col>
    </Row>
  );
});
